<script setup>
import { analysisServiceForMenu } from '@/composables/saju-insight/useAnalysisSajuContext';
import { useStore } from 'vuex';
import { useMobileSajuLnbStore } from '@/store/modules/mobileSajuLnb';
import { useClientType } from '@/composables/useClientType';

import SajuInsightHome from './components/SajuInsightHome.vue';
import AnalysisMobileHeader from '@/components/analysis/AnalysisMobileHeader.vue';
import MobileHeader from '@/components/common/MobileHeader.vue';

definePage({ meta: { layout: 'm-saju-insight' } });

const router = useRouter();
const route = useRoute();
const store = useStore();
const mobileSajuLnbStore = useMobileSajuLnbStore();
const { isApp } = useClientType();
const userId = ref(store.getters['user/id']);
const guestUserId = ref(null);
const homeRef = ref(null);

const close = () => {
  router.push('/saju-service');
};

/** route param에서 guestUserId 초기화 */
const initFromRouteParam = () => {
  const paramId = Number(route.params.id);
  if (paramId) {
    guestUserId.value = paramId;
    mobileSajuLnbStore.setParamData(null);
    mobileSajuLnbStore.setGuestUserId(paramId);
    mobileSajuLnbStore.setMode('normal');
    const service = analysisServiceForMenu(route.query.menu);
    if (service) router.replace({ path: `/m/saju-insight/nangman-${service}`, query: { ...route.query, id: paramId } });
    return true;
  }
  return false;
};

const showInvalidAlert = () => {
  homeRef.value?.showAlert({
    title: '유효하지 않은 사주 정보입니다.',
    nextUrl: homeRef.value?.closeSajuInsight,
  });
  if (homeRef.value) homeRef.value.initializing = false;
};

watch(() => route.params.id, () => {
  if (!initFromRouteParam()) showInvalidAlert();
});

onMounted(async () => {
  if (!userId.value && !sessionStorage.getItem('X-Token')) {
    homeRef.value?.showAlert({
      title: '로그인 후 이용 가능합니다.',
      nextUrl: () => router.push('/auth/login'),
    });
    if (homeRef.value) homeRef.value.initializing = false;
    return;
  }

  if (!initFromRouteParam()) {
    showInvalidAlert();
  }
});
</script>

<template>
  <AnalysisMobileHeader v-if="isApp" title="상세분석" :showPersonIcon="false" @close="close" />
  <MobileHeader
    v-else
    title="상세분석"
    :showBack="true"
    :showMenu="true"
    @back="router.push('/saju-service')"
  />
  <SajuInsightHome ref="homeRef" :guestUserId="guestUserId" />
</template>
